if (!window.Eurus.loadedScript.has('product-comparison.js')) {
  window.Eurus.loadedScript.add('product-comparison.js');

  const applySwatchState = (input) => {
    const { swatchImageUrl: url, swatchProductId: productId } = input.dataset;
    if (url && productId) {
      document.querySelectorAll(`.x-block-summary-block-${productId} .preview-img`).forEach((img) => {
        img.removeAttribute('srcset');
        img.setAttribute('src', url);
      });
    }

    if (!input.name) return;
    document.querySelectorAll(`input[name="${CSS.escape(input.name)}"]`).forEach((groupInput) => {
      const groupLabel = document.querySelector(`label[for="${CSS.escape(groupInput.id)}"]`);
      if (groupLabel) groupLabel.classList.remove('is-selected');
    });
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if (label) label.classList.add('is-selected');
  };

  const syncCheckedSwatches = (scope = document) => {
    scope.querySelectorAll('.swatch-image-trigger:checked').forEach(applySwatchState);
  };

  const moveContentTabletItems = (el) => {
    Array.from(el.getElementsByClassName('content-tablet')).forEach((item) => {
      const target = el.querySelector('.'+item.dataset.selectHtml);
      if (!target) return;
      while (item.firstChild) {
        target.appendChild(item.firstChild);
      }
      item.remove();
    });
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.swatch-image-trigger');
    if (!input) return;
    applySwatchState(input);
  });

  requestAnimationFrame(() => {
    syncCheckedSwatches();

    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductComparisonPopup', {
        loadTablet(el, url) {
          if(url) {
            fetch(url)
              .then(response => response.text())
              .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-comparison-table');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  requestAnimationFrame(() => {
                    el.innerHTML = recommendations.innerHTML;
                    moveContentTabletItems(el);
                    syncCheckedSwatches(el);
                  });
                }
              }).catch(e => {console.error(e);});
          } else {
            moveContentTabletItems(el);
            syncCheckedSwatches(el);
          }
        },
        loadMobile(el, url) {
          if (url) {
            fetch(url)
              .then(response => response.text())
              .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendationsMobile = html.getElementById('product-comparison-table-mobile');
                if (recommendationsMobile && recommendationsMobile.innerHTML.trim().length) {
                  requestAnimationFrame(() => {
                    el.innerHTML = recommendationsMobile.innerHTML;
                    syncCheckedSwatches(el);
                  });
                }
              })
              .catch(e => {
                console.error(e);
              });
          }
        }
      });
      Alpine.data('xProductComparison', () => ({}));
    })
  });
}